import React, {Fragment} from "react"
import {
    Alert,
    Button,
    Card,
    Divider,
    Form,
    Input,
    InputNumber,
    Radio,
    Row,
    Typography,
    notification,
    Select,
    Progress
} from "antd";
import {EuroOutlined, CloseCircleOutlined} from "@ant-design/icons"
import {getDeviseSymbol} from "../../i18n";

import {t} from "@lingui/core/macro"
import logger from "../../services/logger"

const {Text} = Typography

export default class FormSubmit extends React.Component {

    getDeposit() {
        const {config} = this.props
        const submit = config.submit
        const form = config.submit.formData

        const deposit = form.deposit || 0
        const depositPercent = form.depositPercent || 0

        let maxDeposit = deposit
        if (depositPercent) {
            const depositPercentUnit = ((submit.total / 100) / 100) * depositPercent
            if (depositPercentUnit > maxDeposit) {
                maxDeposit = depositPercentUnit
            }
        }

        return maxDeposit
    }

    range(size, startAt = 0) {
        return [...Array(size).keys()].map(i => i + startAt);
    }

    render() {
        const {config, context, devise} = this.props
        const submit = config.submit
        const formData = config.submit.formData

        const deposit = this.getDeposit()
        const payed = submit.total - submit.reste

        const percent = payed * 100 / submit.total

        if (formData.paiementType === "ABONNEMENT") {
            const maxDivide = formData.abonnementMaxMonth || 2
            return (
                <div style={{display: "flex", alignItems: "center", flexDirection: "column", padding: "20px 0%"}}>
                    <Form.Item shouldUpdate={true}>
                        {(form) => {

                            return (
                                <Fragment>
                                    <Form.Item
                                        label={t`Montant`}
                                        name="montant"
                                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                    >
                                        <InputNumber style={{}} size="large" placeholder={t`Montant`}
                                                     addonAfter={getDeviseSymbol(context, devise)} readOnly={true}/>
                                    </Form.Item>

                                    <Form.Item noStyle shouldUpdate>
                                        {(e) => {
                                            const montant = e.getFieldValue("montant");

                                            if (montant < maxDivide) {
                                                return null;
                                            }

                                            return (
                                                <Form.Item name={"divide"} style={{width: "100%"}}>
                                                    <Select style={{width: "100%"}}>
                                                        <Select.Option value={0}>{t`en une seule fois`}</Select.Option>
                                                        {Array.from(Array(maxDivide - 1).keys()).map((i) => {
                                                            const value = i + 2
                                                            return <Select.Option
                                                                value={value}>{t`en ${value} fois soit (${Math.floor(montant / value)}${getDeviseSymbol(context, devise)}/mois)`}</Select.Option>
                                                        })}
                                                    </Select>
                                                </Form.Item>
                                            )
                                        }}
                                    </Form.Item>

                                </Fragment>
                            )
                        }}
                    </Form.Item>
                </div>
            )
        }

        logger.debug({ paiementType: formData.paiementType }, "FormSubmit")

        if (formData.paiementType === "MONTHLY")
        {
            const minAbo = formData.aboMonthMin || 1
            const maxAbo = formData.aboMonthMax || 60

            let aboInfinite=!!formData.aboMonthInfinite || false

            // Liste correcte [minAbo, minAbo+1, ..., maxAbo]
            let nbMonthRange=[]
            for(let i=minAbo;i<=maxAbo;i++){
                nbMonthRange.push(i)
            }

            logger.debug({ minAbo, maxAbo, aboInfinite, nbMonthRange }, "FormSubmit")

            const showFirstChargeAlert = formData.forceBankWithdrawal && formData.firstChargeDate
            const firstChargeDateLabel = showFirstChargeAlert ? new Date(formData.firstChargeDate).toLocaleDateString() : null

            return (
                <div style={{display: "flex", alignItems: "center", flexDirection: "column", padding: "20px 0%"}}>
                    {showFirstChargeAlert && (
                        <Alert
                            type="info"
                            showIcon
                            message={t`Votre prélèvement bancaire commencera le ${firstChargeDateLabel}`}
                            style={{marginBottom: 16, width: "100%"}}
                        />
                    )}
                    <Form.Item shouldUpdate={true}>
                        {(form) => {

                            return (
                                <Fragment>
                                    <Form.Item
                                        label={t`Montant`}
                                        name="montant"
                                        rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                    >
                                        <InputNumber style={{}} size="large" placeholder={t`Montant`}
                                                     addonAfter={getDeviseSymbol(context, devise)} readOnly={true}/>
                                    </Form.Item>

                                    <Form.Item noStyle shouldUpdate>
                                        {(e) => {
                                            if(e.getFieldValue("abo")!==true) {
                                                e.setFieldValue("abo",true)
                                            }

                                            const value = e.getFieldValue("nbMonth")

                                            // Par défaut : on s'engage sur le MIN (le donateur peut augmenter)
                                            if(!aboInfinite && (!value || value<minAbo || value>maxAbo)) {
                                                e.setFieldValue("nbMonth",minAbo)
                                            }

                                            return (
                                                <Fragment>
                                                    <select disabled={this.props.disabled || aboInfinite} className={"form-control"} value={value}
                                                            onChange={(v) => e.setFieldValue("nbMonth", v.target.value)}>

                                                        {aboInfinite &&(
                                                            <option value={0}>{t`En continue - résiliable à tout moment`}</option>
                                                        )}

                                                        {!aboInfinite && nbMonthRange.map((i) => {
                                                            return <option key={i} value={i}>{t`pendant ${i} mois`}</option>
                                                        })}

                                                    </select>
                                                </Fragment>
                                            )
                                        }}
                                    </Form.Item>

                                </Fragment>
                            )
                        }}
                    </Form.Item>
                </div>
            )
        }

        return (
            <div style={{display: "flex", alignItems: "center", flexDirection: "column", padding: "20px 0%"}}>
                <Form.Item shouldUpdate={true}>
                    {(form) => {

                        var min = 1
                        if (deposit && payed === 0) {
                            min = deposit
                        }

                        return (
                            <Fragment>
                                <Form.Item
                                    label={t`Montant`}
                                    name="montant"
                                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                >
                                    <InputNumber style={{}} size="large" min={min} placeholder={t`Montant`}
                                                 addonAfter={getDeviseSymbol(context, devise)}
                                                 readOnly={formData.onePaiement}/>
                                </Form.Item>

                                {!formData.onePaiement && (
                                    <>
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between"
                                        }}>
                                            <Text>{t`Reste`} : {parseFloat(submit.reste / 100).toFixed(2)}€</Text>

                                            {(deposit > 0 && payed === 0) && (
                                                <Text>{t`Acompte`} : {parseFloat(deposit).toFixed(2)}€</Text>
                                            )}
                                        </div>

                                        <Progress
                                            percent={parseInt(percent)}
                                            status="active"
                                            strokeColor={{
                                                from: '#833ab4',
                                                to: '#c53cd4',
                                            }}
                                        />
                                    </>
                                )}

                            </Fragment>
                        )
                    }}
                </Form.Item>
            </div>
        )
    }
}
